import { useWindowWidth } from '@prishapolicy/shared/ui';
import Link from 'next/link';
import Image from 'next/image';
import { twMerge } from 'tailwind-merge';
import { blogTools } from '../helpers';
import { BlogArticleFrontMatter } from '@prishapolicy/markdown';

export const VerticalMdBreakBlogCard = ({ blog }: { blog: BlogArticleFrontMatter }) => {
  const { isMd } = useWindowWidth();
  return (
    <div className="border-grey-400 overflow-hidden rounded-lg border transition duration-300 ease-in-out hover:-translate-y-3 hover:drop-shadow-[-5px_5px_0_rgba(39,55,140,0.5)]">
      <Link href={`/resources/blog/${blog.slug}`} className="block h-full">
        <div className={twMerge(`flex h-full cursor-pointer gap-x-5 overflow-hidden bg-white md:flex-col`)}>
          <Image
            height={222}
            width={450}
            src={`/blog-assets/${blog.slug}/thumbnail.png`}
            alt={blog.title}
            style={{
              height: isMd ? `222px` : `160px`,
              width: !isMd ? `160px` : `auto`,
            }}
          />
          <div
            className={twMerge(`col-span-1 flex  h-[160px] flex-1 flex-col py-4 md:h-full  md:justify-center md:px-8`)}
          >
            <div className="flex flex-1 flex-col ">
              <div className="flex gap-1">{blogTools.badgeRender(blog.tags)}</div>
              <h4 className="lg:text-title-6 text-body-1 mt-1.5 font-bold">{blog.title}</h4>
            </div>
            {blogTools.readTimeAndDate(blog.date, blog.minutesToRead)}
          </div>
        </div>
      </Link>
    </div>
  );
};
